import * as React from 'react';
import { AddButton } from 'ui';
import { MdAdd } from 'react-icons/md';
import { ExternalMembersTableWrapper } from './external-members-table-wrapper';
import { ExternalMembersTilesProps } from '../types';
import { ExternalMembersItem } from './external-members-item';
import { ExternalMembersListHeading } from 'app/area/subscriber-groups/form/components/external-members-list-heading';
import styles from './external-members-tiles.scss';

export const ExternalMembersTiles = (props: ExternalMembersTilesProps) => {
  const { subscriberGroupItem: { externalMembers: externalMember } = {}, addExternalMember, translation } = props;

  return <ExternalMembersTableWrapper>
    {externalMember?.length > 0
      && <div className={styles.listItems}>
        <ExternalMembersListHeading translation={translation} />
        {externalMember.map(item =>
          <ExternalMembersItem
            key={item.memberNo}
            item={item}
            {...props} />)}
      </div>}
    <AddButton icon={MdAdd} onClick={addExternalMember}>
      {translation.add_external_member}
    </AddButton>
  </ExternalMembersTableWrapper>;
};
